__turbopack_context__.v({
  "admin-bg-danger": "PageTitle-module-scss-module__BzqAMq__admin-bg-danger",
  "admin-bg-info": "PageTitle-module-scss-module__BzqAMq__admin-bg-info",
  "admin-bg-primary": "PageTitle-module-scss-module__BzqAMq__admin-bg-primary",
  "admin-bg-secondary": "PageTitle-module-scss-module__BzqAMq__admin-bg-secondary",
  "admin-bg-success": "PageTitle-module-scss-module__BzqAMq__admin-bg-success",
  "admin-bg-warning": "PageTitle-module-scss-module__BzqAMq__admin-bg-warning",
  "admin-border": "PageTitle-module-scss-module__BzqAMq__admin-border",
  "admin-border-dark": "PageTitle-module-scss-module__BzqAMq__admin-border-dark",
  "admin-border-light": "PageTitle-module-scss-module__BzqAMq__admin-border-light",
  "admin-rounded": "PageTitle-module-scss-module__BzqAMq__admin-rounded",
  "admin-rounded-full": "PageTitle-module-scss-module__BzqAMq__admin-rounded-full",
  "admin-rounded-lg": "PageTitle-module-scss-module__BzqAMq__admin-rounded-lg",
  "admin-rounded-md": "PageTitle-module-scss-module__BzqAMq__admin-rounded-md",
  "admin-rounded-sm": "PageTitle-module-scss-module__BzqAMq__admin-rounded-sm",
  "admin-shadow-lg": "PageTitle-module-scss-module__BzqAMq__admin-shadow-lg",
  "admin-shadow-md": "PageTitle-module-scss-module__BzqAMq__admin-shadow-md",
  "admin-shadow-sm": "PageTitle-module-scss-module__BzqAMq__admin-shadow-sm",
  "admin-sr-only": "PageTitle-module-scss-module__BzqAMq__admin-sr-only",
  "admin-text-light": "PageTitle-module-scss-module__BzqAMq__admin-text-light",
  "admin-text-muted": "PageTitle-module-scss-module__BzqAMq__admin-text-muted",
  "admin-text-primary": "PageTitle-module-scss-module__BzqAMq__admin-text-primary",
  "admin-text-secondary": "PageTitle-module-scss-module__BzqAMq__admin-text-secondary",
  "page-title": "PageTitle-module-scss-module__BzqAMq__page-title",
  "page-title--center": "PageTitle-module-scss-module__BzqAMq__page-title--center",
  "page-title--xl": "PageTitle-module-scss-module__BzqAMq__page-title--xl",
  "page-title__container": "PageTitle-module-scss-module__BzqAMq__page-title__container",
  "page-title__container--no-bottom": "PageTitle-module-scss-module__BzqAMq__page-title__container--no-bottom",
  "page-title__container--no-top": "PageTitle-module-scss-module__BzqAMq__page-title__container--no-top",
  "page-title__container--no-vertical": "PageTitle-module-scss-module__BzqAMq__page-title__container--no-vertical",
  "page-title__description": "PageTitle-module-scss-module__BzqAMq__page-title__description",
  "page-title__title": "PageTitle-module-scss-module__BzqAMq__page-title__title",
});
